/* eslint-disable radix */
/* eslint-disable operator-linebreak */
/* eslint-disable comma-dangle */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
/* eslint-disable no-plusplus */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef, useEffect, useState } from 'react';
import { Form } from '@unform/web';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import Input from '~/components/Input';
import ImageInput from '../../Modules/ImageInput';
import { Container, Header, Row, ButtonTest } from './styles';

import history from '~/services/history';
import api from '~/services/api';

export default function Cards() {
  const { id } = useParams();
  const formRef = useRef(null);
  const [modules, setModules] = useState([]);
  const [job, setJob] = useState('');
  const [file, setFile] = useState('');
  const [statusJob, setStatusJob] = useState('');
  const [company, setCompany] = useState('');
  const [title, setTitle] = useState('');
  const [type, setType] = useState('');
  const [local, setLocal] = useState('');
  const [tags, setTags] = useState('');
  const [remote, setRemote] = useState('');
  const [salary, setSalary] = useState('');
  const [description, setDescription] = useState('');
  const [apolloLevel, setApolloLevel] = useState('');
  const [business1, setBusiness1] = useState('');
  const [business2, setBusiness2] = useState('');
  const [business3, setBusiness3] = useState('');
  const [tech1, setTech1] = useState('');
  const [tech2, setTech2] = useState('');
  const [tech3, setTech3] = useState('');
  const [tech4, setTech4] = useState('');
  const [tech5, setTech5] = useState('');
  const [tech6, setTech6] = useState('');

  useEffect(() => {
    async function getDataModules() {
      const { data } = await api.get('/modules');
      setModules(data);
    }
    async function getDataJobs() {
      const { data } = await api.get(`/jobs/${id}`);
      setJob(data);
      setFile(data.file);
      setStatusJob(data.status);
      setDescription(data.description);
      setApolloLevel(data.apollo_level);
      setCompany(data.company);
      setTitle(data.title);
      setType(data.type_job);
      setLocal(data.local);
      setTags(data.area_job);
      setRemote(data.remote_job);
      setSalary(data.salary);
      setBusiness1(data.business1_id);
      setBusiness2(data.business2_id);
      setBusiness3(data.business3_id);
      setTech1(data.development1_id);
      setTech2(data.development2_id);
      setTech3(data.development3_id);
      setTech4(data.development4_id);
      setTech5(data.development5_id);
      setTech6(data.development6_id);
    }
    getDataModules();
    getDataJobs();
  }, [id]);

  async function handleSubmit(data, { reset }) {
    try {
      const apollo_level = parseInt(apolloLevel);
      const business1_id = parseInt(business1);
      const business2_id = parseInt(business2);
      const business3_id = parseInt(business3);
      const development1_id = parseInt(tech1);
      const development2_id = parseInt(tech2);
      const development3_id = parseInt(tech3);
      const development4_id = parseInt(tech4);
      const development5_id = parseInt(tech5);
      const development6_id = parseInt(tech6);

      await api.put(`/jobs/${id}`, {
        status: statusJob,
        company,
        title,
        type_job: type,
        local,
        area_job: tags,
        description,
        remote_job: remote,
        salary,
        apollo_level,
        business1_id,
        business2_id,
        business3_id,
        development1_id,
        development2_id,
        development3_id,
        development4_id,
        development5_id,
        development6_id,
      });

      return toast.success('Job cadastrado com sucesso');
    } catch (error) {
      return toast.error('Erro ao atualizar a vaga, tente novamente');
    }
  }

  async function handleSubmitImage(data) {
    const { file_id } = data;

    try {
      await api.put(`/jobs/${id}`, {
        file_id,
      });

      return toast.success('Imagem da Vaga atualizada com sucesso');
    } catch (error) {
      return toast.error('Erro ao atualizar a Imagem da Vaga');
    }
  }

  return (
    <>
      <Header>
        <ButtonTest type="submit" onClick={() => history.push('/level')}>
          <h2>Level</h2>
        </ButtonTest>
        <ButtonTest type="submit" onClick={() => history.push('/subject')}>
          <h2>Subject</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/module')}>
          <h2>Modules</h2>
        </ButtonTest>

        {/* <ButtonTest type="submit" onClick={() => history.push('/card')}>
          <h2>Cards</h2>
        </ButtonTest> */}

        <ButtonTest type="submit" onClick={() => history.push('/challenge')}>
          <h2>Challenges</h2>
        </ButtonTest>

        <ButtonTest
          selected
          type="submit"
          onClick={() => history.push('/jobs')}
        >
          <h2>Jobs</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/file')}>
          <h2>Files</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/users')}>
          <h2>Users</h2>
        </ButtonTest>
      </Header>

      <Container>
        <h1>Dados da Vaga:</h1>
        <div className="support">
          <img src={file.url} alt="Logo" style={{ witdh: 100, height: 80 }} />
          <div className="select">
            <span>Status da Vaga:</span>
            <p>{job.status}</p>
          </div>
        </div>

        <div className="support" style={{ marginTop: 30 }}>
          <div className="select">
            <span>Nome da Empresa:</span>
            <p>{job.company}</p>
          </div>
          <div className="select">
            <span>Titulo da Vaga:</span>
            <p>{job.title}</p>
          </div>
          <div className="select">
            <span>Tipo da Vaga:</span>
            <p>{job.type_job}</p>
          </div>
        </div>

        <div className="support" style={{ marginTop: 30 }}>
          <div className="select">
            <span>Local de Trabalho:</span>
            <p>{job.local}</p>
          </div>
          <div className="select">
            <span>Tags da Vaga:</span>
            <p>{job.area_job}</p>
          </div>
          <div className="select">
            <span>Trabalho Remoto:</span>
            <p>{job.remote_job}</p>
          </div>
          <div className="select">
            <span>Salário:</span>
            <p>{job.salary ? job.salary : 'Sem Valor'}</p>
          </div>
        </div>

        <div
          className="support"
          style={{ marginTop: 30, justifyContent: 'center' }}
        >
          <div className="select">
            <span>Descriçāo da Vaga:</span>
            <p>{job.description}</p>
          </div>
        </div>

        <div className="support" style={{ marginTop: 30 }}>
          <div className="select">
            <span>Nível Apollo:</span>
            <p>{job.apollo_level}</p>
          </div>
          <div className="select">
            <span>Business #1:</span>
            <p>{job.business1_id}</p>
          </div>
          <div className="select">
            <span>Business #2:</span>
            <p>{job.business2_id}</p>
          </div>
          <div className="select">
            <span>Business #3:</span>
            <p>{job.business3_id}</p>
          </div>
        </div>

        <div className="support" style={{ marginTop: 30 }}>
          <div className="select">
            <span>Tecnologia #1:</span>
            <p>{job.development1_id}</p>
          </div>
          <div className="select">
            <span>Tecnologia #2:</span>
            <p>{job.development2_id}</p>
          </div>
          <div className="select">
            <span>Tecnologia #3:</span>
            <p>{job.development3_id}</p>
          </div>
          <div className="select">
            <span>Tecnologia #4:</span>
            <p>{job.development4_id}</p>
          </div>
          <div className="select">
            <span>Tecnologia #5:</span>
            <p>{job.development5_id}</p>
          </div>
          <div className="select">
            <span>Tecnologia #6:</span>
            <p>{job.development6_id}</p>
          </div>
        </div>
      </Container>

      <Container>
        <h1>Editar Vaga:</h1>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <div className="support">
            <div className="select">
              <span>Status da Vaga:</span>
              <select
                value={statusJob}
                onChange={(e) => setStatusJob(e.target.value)}
              >
                <option disabled>Seleciona uma opçāo</option>
                <option value="open">Aberto</option>
                <option value="closed">Fechado</option>
                <option value="paused">Pausado</option>
              </select>
            </div>
          </div>

          <div className="support">
            <input
              type="text"
              placeholder="Nome da Empresa"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
            />
            <input
              type="text"
              placeholder="Titulo da Vaga"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <input
              type="text"
              placeholder="Tipo da Vaga (Integral, meio periodo...)"
              value={type}
              onChange={(e) => setType(e.target.value)}
            />
          </div>

          <div className="support">
            <input
              type="text"
              placeholder="Local (Sāo Paulo/SP"
              value={local}
              onChange={(e) => setLocal(e.target.value)}
            />
            <input
              type="text"
              placeholder="Tags (Mobile, FullStack, BPM, DEVOPS)"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
            />
            <input
              type="text"
              placeholder="Trabalho Remoto? (yes, no, partial)"
              value={remote}
              onChange={(e) => setRemote(e.target.value)}
            />
            <input
              type="integer"
              placeholder="Salário R$"
              value={salary}
              onChange={(e) => setSalary(e.target.value)}
            />
          </div>

          <textarea
            type="text"
            placeholder="Descreva sobre a vaga"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          <div className="select">
            <span>Nível Apollo:</span>
            <select
              value={apolloLevel}
              onChange={(e) => setApolloLevel(e.target.value)}
            >
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              <option value={1}>Iniciante</option>
              <option value={2}>Básico</option>
              <option value={3}>Intermediário</option>
              <option value={4}>Avançado</option>
              <option value={5}>Master</option>
            </select>
          </div>

          <div className="select" style={{ marginTop: 30 }}>
            <span>Certificados de Negócios:</span>
            <span>Certificado #1</span>
            <select
              value={business1}
              onChange={(e) => setBusiness1(e.target.value)}
            >
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'business' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #2</span>
            <select
              value={business2}
              onChange={(e) => setBusiness2(e.target.value)}
            >
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'business' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #3</span>
            <select
              value={business3}
              onChange={(e) => setBusiness3(e.target.value)}
            >
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'business' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
          </div>

          <div className="select" style={{ marginTop: 30 }}>
            <span>Certificados de Tecnologias:</span>
            <span>Certificado #1</span>
            <select value={tech1} onChange={(e) => setTech1(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #2</span>
            <select value={tech2} onChange={(e) => setTech2(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #3</span>
            <select value={tech3} onChange={(e) => setTech3(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #4</span>
            <select value={tech4} onChange={(e) => setTech4(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #5</span>
            <select value={tech5} onChange={(e) => setTech5(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
            <span>Certificado #6</span>
            <select value={tech6} onChange={(e) => setTech6(e.target.value)}>
              <option value="open" disabled>
                Seleciona uma opçāo
              </option>
              {modules.map((module) =>
                module.subject.type === 'development' ? (
                  <option key={module.id} value={`${module.id}`}>
                    {module.title}
                  </option>
                ) : null
              )}
            </select>
          </div>

          <button className="form" type="submit">
            ATUALIZAR
          </button>
        </Form>

        <Form ref={formRef} onSubmit={handleSubmitImage}>
          <div className="image">
            <span>Imagem:</span>
            <ImageInput name="file_id" />
          </div>
          <button className="form" type="submit">
            ATUALIZAR IMAGEM
          </button>
        </Form>
      </Container>
    </>
  );
}
